// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PsWX","tabsBox":"styles_tabsBox__lHI9t","createButton":"styles_createButton__hR4cE"};